import axios from 'axios'
import router from '@/router'
import store from './store/store';

const baseURL = 'https://api.ira-lex.com/'
// const baseURL = 'https://newback.ira-lex.com/'
// const baseURL = 'http://192.168.2.125:8000/'
// const baseURL = 'https://test.ira-lex.com/'
// const baseURL = 'https://newiralexapi.ira-lex.com/'

// 'Cache-Control': 'no-cache',
//   'Pragma': 'no-cache',
//   'Expires': '0',

const ax = axios.create({
  baseURL,
  headers: {
      'Access-Control-Allow-Header': 'Content-Type',
      'Accept': "application/json",
      'Content-Type' : 'application/json',
      'Auth': localStorage.getItem("accessToken") || localStorage.accessToken,
  }
})


ax.interceptors.request.use(
  config => {
    config.headers["Auth"] = localStorage.getItem("accessToken");
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

ax.interceptors.response.use(function (res) {
  return res;
}, function ({response}) {
  if (response.status === 401) {
    router.push({path:'/pages/not-authorized'});
  }
  if (response.data && response.status === 419) {
    store.commit('STATUS_ACCOUNT',response.data.status)
    router.push({ path:'/permission-denied' }).catch(()=>{});
  }
  // if (response.status === 500) {
  //   router.push({path:'/pages/error-500'});
  // }
  return Promise.reject(response);
});

export default ax;

